import React, { Context } from 'react';
import {
  Provider,
  ReactReduxContextValue,
  createDispatchHook,
  createSelectorHook,
  createStoreHook,
} from 'react-redux';
import { AnyAction, createStore } from 'redux';
import { ApplicationState } from 'src/researcher/types/application';
import { applicationStateReducer } from './reducer';

const ApplicationStoreContext: Context<ReactReduxContextValue<ApplicationState, AnyAction>> =
  React.createContext(null) as unknown as Context<
    ReactReduxContextValue<ApplicationState, AnyAction>
  >;

export const useApplicationStore = createStoreHook(ApplicationStoreContext);
export const useApplicationDispatch = createDispatchHook(ApplicationStoreContext);
export const useApplicationState = createSelectorHook(ApplicationStoreContext);

const ApplicationStore = createStore(applicationStateReducer as any);

interface ApplicationProviderProps {
  children: JSX.Element | JSX.Element[] | string | null;
}

export function ApplicationProvider(props: ApplicationProviderProps) {
  return (
    <Provider context={ApplicationStoreContext} store={ApplicationStore}>
      {props.children}
    </Provider>
  );
}
